const getUrlFromCDN = (provider, url) => (
  provider === 'aws-s3'
    ? `${process.env.NEXT_PUBLIC_ASSET_HOST}${new URL(url).pathname}`
    : url
);

export default getUrlFromCDN;
